module.exports = __webpack_public_path__ + "media/marketing_campaigns/triggers-0fad5694.svg";